<div class="chat-wrap" [hidden]="">
    <app-group-chat-top [selectedGroup]="selectedGroupMessages"
                        [authUser]="authUser"></app-group-chat-top>
    <app-group-chat-messages [authUser]="authUser" [selectedGroupMessages]="selectedGroupMessages"></app-group-chat-messages>
</div>
